import { render } from "./InformeRentabilidadGlobal.vue?vue&type=template&id=68b1942e&scoped=true"
import script from "./InformeRentabilidadGlobal.vue?vue&type=script&lang=js"
export * from "./InformeRentabilidadGlobal.vue?vue&type=script&lang=js"

import "./InformeRentabilidadGlobal.vue?vue&type=style&index=0&id=68b1942e&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b1942e"]])

export default __exports__